/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ApiClient } from '../types/api/ApiClient';
import { PostgresVersion } from '../types/product/PostgresVersion';
import { getApiEndpoint } from '../utils/getApiEndpoint';
import { apiClientFactory } from '../utils/http-client/apiClientFactory';
import { axiosInstanceFactory } from '../utils/http-client/axiosInstanceFactory';
import { axiosJwtTokenInterceptor, axiosUnauthorizedInterceptor } from '../utils/http-client/axiosInterceptors';

class SuperuserPostgresVersionApiServiceClass {
  #baseURL = '/product/pgversion';
  #api: ApiClient;

  constructor() {
    this.#api = apiClientFactory(
      axiosInstanceFactory(
        { baseURL: getApiEndpoint() },
        [axiosJwtTokenInterceptor],
        [[undefined, axiosUnauthorizedInterceptor]],
      ),
    );
  }

  fetchPostgresVersions = () => this.#api.get<PostgresVersion>(this.#baseURL);
}

export const SuperuserPostgresVersionApiService = new SuperuserPostgresVersionApiServiceClass();
